var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44444 15.2222C5.44444 16.2041 4.64851 17 3.66667 17C2.68483 17 1.88889 16.2041 1.88889 15.2222C1.88889 14.2404 2.68483 13.4444 3.66667 13.4444C4.64851 13.4444 5.44444 14.2404 5.44444 15.2222ZM5.44444 15.2222H12.5556C13.5374 15.2222 14.3333 14.4263 14.3333 13.4444V9.88889M12.5556 2.77778C12.5556 3.75962 13.3515 4.55556 14.3333 4.55556C15.3152 4.55556 16.1111 3.75962 16.1111 2.77778C16.1111 1.79594 15.3152 1 14.3333 1C13.3515 1 12.5556 1.79594 12.5556 2.77778ZM12.5556 2.77778H5.44444C4.4626 2.77778 3.66667 3.57372 3.66667 4.55556V8.11111M17 11.6667L14.6476 9.13983C14.474 8.95339 14.1926 8.95339 14.0191 9.13983L11.6667 11.6667M6.33333 6.33333L3.98094 8.86017C3.80737 9.04661 3.52596 9.04661 3.3524 8.86017L1 6.33333",
    stroke: "#3C4242",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return_icon.a3b965ba831baa617873548287643c72.svg";
export { ForwardRef as ReactComponent };